<template lang="pug">
b-table.table-outline.mb-0(hover, responsive, outline, head-variant='default', :items='data', :fields='label', :small='small', @row-clicked='ping', :sort-by.sync="sortBy", :sort-desc.sync="sortDesc")
  //- template(slot='avatar' scope='item')
    div.avatar
      img.img-avatar(:src='item.value.url || "static/img/avatars/0.png"', alt='', v-b-tooltip.hover='userIdString(item.value.tooltip)', v-if='item.value.tooltip')
      span.avatar-status(:class='item.value.status ? "bg-" + item.value.status : "bg-danger"', v-if='item.value.status')
      span.avatar-platform.fa(:class='[item.value.platform == "fb" && "fa-facebook-official", item.value.platform == "whatsapp" && "fa-whatsapp", item.value.platform != "whatsapp" && item.value.platform != "fb" && "fa-globe"]', v-if='item.value.platform')
  template(slot='name', scope='item')
    span.bold(v-if='item.value=="Total Intents"||item.value=="Total Unmatched"||item.value=="Total Matched"||item.value=="Total Conversations"')
      | {{item.value}}
    span(v-else)
      | {{item.value}}
  template(slot='number', scope='item')
    span.bold
      | {{item.value}}
  template(slot='percent', scope='item')
    span.bold
      | {{item.value}}
  template(slot='timestamp', scope='item')
    | {{item.value | moment("from", "now")}}
</template>
<script>
import moment from 'moment'

export default {
  name: 'app-conversationtopictable',
  data: function() {
    return {
      messageModel: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      sortDesc: true,
      sortBy: null,
    }
  },
  props: {
    small: false,
    rowClick: false,
    rowBroadcastClick: false,
    sending: false,
    data: {
      type: Array,
      default: () => [],
    },
    label: {
      type: Object,
      default: () => {
        return {
        }
      },
    },
  },
  methods: {
    focus(id) {
      setTimeout(function() {
        document.getElementById('input' + id).focus()
      }, 100)
    },
    ping (e) {
      this.rowClick && this.$router.push({ name: 'Interaction', params: { userId: e.userId } })
      // this.rowBroadcastClick && this.$router.push({ name: 'Broadcast', params: { Id: e.broadcastActions } })
    },
    convertTimeFormat(timestamp) {
      return moment(timestamp, 'x').format("Do MMM 'YY, hh:mmA")
    },
    chatLink (value) {
      return { name: 'Interaction', params: { userId: value } }
    },
    userIdString (value) {
      return value ? value.toString() : ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ConversationTopicTable.vue?13ff3cce